// The Vue build version to load with the `import` command
// (runtime-only or standalone) has been set in webpack.base.conf with an alias.
import Vue from 'vue'
import App from './App'
import router from './router'
import store from './store'
import BootstrapVue from 'bootstrap-vue'
import authentication from './authentication'
import VueAnalytics from 'vue-analytics'
import './helpers/axios-config'; // Import the Axios configuration

Vue.config.productionTip = false

Vue.use(VueAnalytics, {
  id: 'UA-58355767-4',
  router
})

authentication.initialize().then(_ => {
/* eslint-disable no-new */
  new Vue({
    el: '#app',
    router,
    store,
    components: { App },
    template: '<App/>'
  })
})

Vue.use(BootstrapVue)



// WEBPACK FOOTER //
// ./src/main.js